/** Ширина и clamp боковых панелей тактического workspace (как у VisualizerLayersPanel). */

export const TACTICAL_RAIL_WIDTH_MIN = 240;
export const TACTICAL_RAIL_WIDTH_DEFAULT = 288;
export const TACTICAL_RAIL_WIDTH_COLLAPSED = 40;

export function maxTacticalRailWidthPx(): number {
  if (typeof window === "undefined") return 800;
  return Math.max(TACTICAL_RAIL_WIDTH_MIN, Math.floor(window.innerWidth * 0.45));
}

export function clampTacticalRailWidth(px: number): number {
  return Math.min(maxTacticalRailWidthPx(), Math.max(TACTICAL_RAIL_WIDTH_MIN, Math.round(px)));
}

export function readRailCollapsed(storageKey: string): boolean {
  try {
    return sessionStorage.getItem(storageKey) === "1";
  } catch {
    return false;
  }
}

export function writeRailCollapsed(storageKey: string, collapsed: boolean): void {
  try {
    sessionStorage.setItem(storageKey, collapsed ? "1" : "0");
  } catch {
    /* ignore */
  }
}

export function readRailWidth(storageKey: string, fallback = TACTICAL_RAIL_WIDTH_DEFAULT): number {
  try {
    const raw = Number(sessionStorage.getItem(storageKey));
    if (Number.isFinite(raw)) return clampTacticalRailWidth(raw);
  } catch {
    /* ignore */
  }
  return fallback;
}

export function writeRailWidth(storageKey: string, widthPx: number): void {
  try {
    sessionStorage.setItem(storageKey, String(clampTacticalRailWidth(widthPx)));
  } catch {
    /* ignore */
  }
}
